import React, { useState, useEffect } from "react";
import { formatMoneda } from "../../util/varios";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTableFijo from "../useTableFijo";
import moment from "moment";

const TablaVerificacionesProduc = (props) => {
  const headCells = [
    {
      id: "1",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-code">
          {" "}
          CÓDIGO
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-calendar-week">
          {" "}
          PERIODO
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-money-bill">
          {" "}
          CUENTA BANCARIA
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "4",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: (
        <i
          style={{ textAlign: "center" }}
          className="fas fa-money-bill-wave-alt"
        >
          {" "}
          MONTO TOTAL
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "5",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-calendar-day">
          {" "}
          FECHA DE VERIFICACIÓN{" "}
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "6",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-check-square">
          {" "}
          ESTATUS
        </i>
      ),
      textAlign: "center",
    },
  ];

  const [records, setRecords] = useState([]);

  const { TblContainer, TblHead, TblPagination } = useTableFijo(
    records,
    headCells,
    {
      fn: (items) => {
        return items;
      },
    },
    280
  );

  useEffect(() => {
    if (props.verific) {
      setRecords(props.verific);
    }
  }, [props.verific]);

  return (
    <div className="card">
      <div className="card-body">
        <div className="content">
          <div className="container">
            <div className="row" style={{ margin: 0 }}>
              <div className="col-md-12" style={{ margin: "auto" }}>
                <TblContainer>
                  <TblHead />

                  <TableBody>
                    {records &&
                      records.map((item, index) => (
                        <TableRow
                          key={item.anio + item.mes}
                          style={{ padding: "0" }}
                        >
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {item.idverificacion}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {item.periodo}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "right" }}
                          >
                            {item.cuentabancaria}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "right" }}
                          >
                            {formatMoneda(
                              item.totalfactura.toString().replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {moment(item.fechaverificacion).format(
                              "DD/MM/YYYY"
                            )}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {item.status === 1
                              ? "La Verificación ya fue Pagada"
                              : "Verificación por Pagar"}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </TblContainer>
                <TblPagination />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TablaVerificacionesProduc;



// WEBPACK FOOTER //
// ./src/components/agentes/tablaVerificaciones.js